const map: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
};

const escapeHtml = (text: string | string[]) => {
    const _replace = (t: string) => t.replace(/[&<>"']/g, m => map[m]);
    if (typeof text === 'string') {
        return _replace(text);
    }
    return text.map(_t => _replace(_t));
};

export default escapeHtml;
